// extracted by mini-css-extract-plugin
export default {"ctn":"stable_ctn__O7sVn","textBox":"stable_textBox__0hw6f","videoBox":"stable_videoBox__5X83n","mobile":"stable_mobile__W0Z2l","stabilizer":"stable_stabilizer__ES9wZ"};